import { useState } from 'react'
import viaCepApi from 'services/viaCepApi'
import { logApiError } from 'services/apiError'
import addressValidator from 'validators/addressValidator'
import { ReactComponent as Loading } from 'icons/loading2.svg'
import { MdNavigateNext } from 'react-icons/md'
import { Formik } from 'formik'

import {
  Row,
  Form,
  Button,
  SubTitle,
  FormField,
  WarningText,
  Input,
  MaskedInput,
  LoadingBackdrop,
  AddressContainer
} from '../styles'

export default function AddressForm ({
  companyData = {},
  onFormSubmitted: handleFormSubmitted = () => null
}) {
  const [loadingAddress, setLoadingAddress] = useState (false)

  return (
    <Formik
      validationSchema={addressValidator}
      initialValues={companyData.address}
      onSubmit={values => handleFormSubmitted ({ address: values })}
    >
      {function SignUpAddressForm ({
        values,
        errors,
        touched,
        setFieldValue,
        handleChange,
        handleBlur,
        handleSubmit
      }) {
        const searchAddress = async event => {
          const postal_code = event.target.rawValue

          setFieldValue ('postal_code', postal_code)
          
          if (postal_code.length === 8) {
            setLoadingAddress (true)
            try {
              const response = await viaCepApi.get (`/ws/${postal_code}/json`)
              const { data } = response

              setFieldValue ('route', data.logradouro)
              setFieldValue ('district', data.bairro)
              setFieldValue ('city', data.localidade)
              setFieldValue ('state', data.uf)
            } catch (error) {
              logApiError (error)
            } finally {
              setLoadingAddress (false)
            }
          }
        }

        return (
          <Form onSubmit={handleSubmit} style={{ width: 800 }}>
            <SubTitle>Endereço da empresa</SubTitle>
            <AddressContainer>
              {loadingAddress && (
                <LoadingBackdrop>
                  <Loading/>
                </LoadingBackdrop>
              )}
              <Row>
                <FormField>
                  <MaskedInput
                    id='postal_code'
                    name='postal_code'
                    placeholder='CEP'
                    options={{
                      blocks: [5, 3],
                      delimiters: ['-'],
                      numericOnly: true
                    }}
                    value={values.postal_code}
                    onChange={searchAddress}
                    onBlur={handleBlur ('postal_code')}
                  />
                  {touched.postal_code && errors.postal_code && (
                    <WarningText>{errors.postal_code}</WarningText>
                  )}
                </FormField>
                <FormField stretch={2}>
                  <Input placeholder='Rua/avenida' value={values.route} disabled/>
                </FormField>
                <FormField>
                  <Input
                    placeholder='Número'
                    value={values.number}
                    onChange={handleChange ('number')}
                    onBlur={handleBlur ('number')}
                  />
                  {touched.number && errors.number && (
                    <WarningText>{errors.number}</WarningText>
                  )}
                </FormField>
                <FormField>
                  <Input
                    placeholder='Complemento'
                    value={values.complement}
                    onChange={handleChange ('complement')}
                    onBlur={handleBlur ('complement')}
                  />
                </FormField>
              </Row>
              <Row>
                <FormField stretch={2}>
                  <Input placeholder='Bairro' value={values.district} disabled/>
                </FormField>
                <FormField>
                  <Input placeholder='Cidade' value={values.city} disabled/>
                </FormField>
                <FormField>
                  <Input placeholder='Estado' value={values.state} disabled/>
                </FormField>
              </Row>
            </AddressContainer>
            <Button type='submit'>
              <MdNavigateNext size={30}/>
            </Button>
          </Form>
        )
      }}
    </Formik>
  )
}
